import React from 'react';
import { SvgIcon, Image } from 'seduo-ui';
import classNames from 'classnames';
const CourseImage = ({ src, srcSet, sizes, alt, isFinished, className, overlayTextBottomRight }) => (<div className={classNames('course-image', className)}>
        <Image className="course-image__image" src={src} srcSet={srcSet} sizes={sizes} alt={alt}/>
        {isFinished && (<div className="course-image__overlay course-image__overlay--full">
                <SvgIcon className="course-image__overlay-icon" kind="CheckCircle" size={22}/>
            </div>)}
        {overlayTextBottomRight && !isFinished && (<div className="course-image__overlay course-image__overlay--bottom-right">{overlayTextBottomRight}</div>)}
    </div>);
export default CourseImage;
